<template>
  <div></div>
</template>

<script>
export default {
  name: "ActionReport",
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
  props: {
    assessment: {
      type: Object,
    },
    permissions: {
      type: Object,
    },
  },
};
</script>
